import React, { Component } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';

class TodoItem extends Component {

  state = {
    name : "",
    done : false
  };

  constructor(props) {
    super(props);

    this.state = {
      name : props.item.name,
      done: props.item.done
    };
  }

  onChange = (toggle) => {
    console.log(toggle)
  }

  render() {
    return (
      <Box mt={1}>
        <Paper>
          <Box pl={1}>
            <FormGroup row>
              <FormControlLabel
                style={{width:"100%", height:"50px", margin:"0px"}}
                control={<Checkbox/>}
                onChange={this.onChange}
                value={this.state.done}
                label={this.state.name}/>
            </FormGroup>
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default TodoItem;



// WEBPACK FOOTER //
// ./src/comps/TodoItem.js